export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const checkValidity = (value, roles) => {
  let isValid = true;
  if (!roles) {
    return true;
  }
  if (isValid && roles.required) {
    if (value == null || value == undefined) {
      isValid = false;
    } else {
      isValid = value.trim() !== "" && isValid;
    }
  }
  if (isValid && roles.minLenght && value) {
    isValid = value.length >= roles.minLenght && isValid;
  }
  if (isValid && roles.maxLength && value) {
    isValid = value.length <= roles.maxLength && isValid;
  }
  if (isValid && roles.min && value) {
    isValid = parseFloat(value) >= roles.min && isValid;
  }
  if (isValid && roles.max && value) {
    isValid = parseFloat(value) <= roles.max && isValid;
  }
  if (isValid && roles.isEmail && value) {
    isValid = value.length <= roles.maxLength && isValid;
  }
  if (isValid && roles.isMobile) {
    var mobileRegex = /^09[0-9]{9}/;
    isValid = mobileRegex.test(value);
  }
  if (isValid && roles.isNationalId) {
    isValid = IsIRNationalCodeValid(value);
  }
  if (isValid && roles.isPostalCode) {
    isValid = IsPostalCodeValid(value);
  }
  if (isValid && roles.realOrLegal) {
    isValid = IsIRNationalCodeValid(value) || IsLegalNationalCodeValid(value);
  }
  if (isValid && roles.justNumber) {
    isValid = !isNaN(value);
  }
  return isValid;
};
export const IsIRNationalCodeValid = (theNum) => {
  if (theNum.length != 10) {
    return false;
  } else {
    if (theNum.substr(0, 3) == "000") {
      return false;
    }
    var check = 0;
    for (var i = 0; i < theNum.length; i++) {
      var num = theNum.substr(i, 1);
      check += num * (10 - i);
    }
    if (check % 11) {
      return false;
    } else {
      return true;
    }
  }
};
export const IsLegalNationalCodeValid = (value) => {
  var isValid = true;
  if (isNaN(value)) {
    isValid = false;
  } else if (value == "") {
    isValid = false;
  } else if (value.length < 11) {
    isValid = false;
  } else if (parseInt(value.substring(3, 9)) == 0) {
    isValid = false;
  }
  var c = parseInt(value.substring(10, 11));
  var d = parseInt(value.substring(9, 10)) + 2;
  var z = [29, 27, 23, 19, 17];
  var s = 0;

  for (var i = 0; i < 10; i++)
    s += (d + parseInt(value.substring(i, i + 1))) * z[i % 5];

  s = s % 11;

  if (s == 10) s = 0;
  return c == s;
};
function IsPostalCodeValid(theNum) {
  if (theNum.length != 10) {
    return false;
  }
  return true;
}
